// extracted by mini-css-extract-plugin
module.exports = {"AwesomeInput":"AwesomeInput_AwesomeInput__4uL0v","SearchResult":"AwesomeInput_SearchResult__3P019","HomeIcon":"AwesomeInput_HomeIcon__3nfTD"};